function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "512",
  height: "100",
  rx: "50",
  ry: "50"
}), /*#__PURE__*/React.createElement("rect", {
  y: "206",
  width: "512",
  height: "100",
  rx: "50",
  ry: "50"
}), /*#__PURE__*/React.createElement("rect", {
  y: "412",
  width: "512",
  height: "100",
  rx: "50",
  ry: "50"
}));